import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const YamlToJsonConverterContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Intro */}
      <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "1.75rem" }} gutterBottom>
        YAML to JSON Converter – Instantly Convert YAML Files to JSON Format
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Effortlessly Convert YAML Data to JSON for Easy Integration and Use
      </Typography>
      <Typography variant="body1" paragraph>
        Need a fast and reliable way to convert YAML into JSON? Our tool makes it simple to transform your YAML files into JSON format, helping developers and data professionals work with structured data seamlessly.
      </Typography>
      <Typography variant="body1" paragraph>
        Whether you're configuring apps, writing APIs, or managing DevOps pipelines, our YAML to JSON converter lets you convert and export your data in just a few clicks.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use Our YAML to JSON Converter?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>⚡ Instantly convert YAML files into JSON format with one click</li>
        <li>🔄 Handle complex, nested YAML structures with ease</li>
        <li>📝 Clean, readable JSON output ready for APIs, configs, or scripts</li>
        <li>📥 Download your JSON file or copy it directly to your clipboard</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Use the YAML to JSON Converter
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Upload your YAML file or paste the YAML data into the editor.</li>
        <li>Click “Convert to JSON” to automatically process and generate the JSON output.</li>
        <li>Copy the JSON to your clipboard or download it as a file.</li>
      </ol>

      {/* SEO Paragraph */}
      <Typography variant="body1" paragraph mt={4}>
        Our <b>YAML to JSON converter</b> is trusted by developers, DevOps engineers, and businesses worldwide to convert configuration files, API specs, and deployment templates into JSON. Whether you're working with Kubernetes configs, CI/CD pipelines, or app settings, our tool delivers accurate, structured JSON in seconds.
      </Typography>

      <Typography variant="body1" paragraph>
        Stop manually rewriting YAML into JSON—let our <b>YAML to JSON converter</b> handle it so you can focus on coding and deploying with confidence.
      </Typography>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>
      <Typography variant="body1" fontWeight="bold">💡 What is a YAML to JSON converter?</Typography>
      <Typography variant="body2" paragraph>
        A YAML to JSON converter is a tool that takes YAML data and transforms it into JSON format, making it easier to integrate with APIs, applications, and tools that consume JSON.
      </Typography>

      <Typography variant="body1" fontWeight="bold">🆓 Is the YAML to JSON converter free?</Typography>
      <Typography variant="body2" paragraph>
        For Free plan users, 1 credit will be deducted for each conversion. All Paid plan users enjoy this tool for free 🎁 without any credit deduction.
      </Typography>

      <Typography variant="body1" fontWeight="bold">👩‍💻 Who should use a YAML to JSON converter?</Typography>
      <Typography variant="body2" paragraph>
        Developers, DevOps engineers, system administrators, or anyone working with YAML-based configuration files will benefit from using this tool to quickly convert to JSON.
      </Typography>

      {/* CTA */}
      <Box mt={4}>
        <Button variant="contained" color="primary" size="large" onClick={scrollToTop}>
          Convert YAML to JSON Now
        </Button>
      </Box>
    </Container>
  );
};

export default YamlToJsonConverterContent;
